import { IServiceRequest, IServiceRequestQuote } from '../interfaces/heavyDutyMachinery/IServiceRequest';

/**
 * The version on the table right now.
 *
 * By version number rather than by array order: the server sends them oldest
 * first today, and a screen that silently depends on that ordering is a screen
 * that shows the wrong price the day it changes.
 */
export const latestServiceQuote = (request: IServiceRequest): IServiceRequestQuote | undefined =>
  request.quoteHistory?.length
    ? request.quoteHistory.reduce((latest, quote) => (quote.versionNumber > latest.versionNumber ? quote : latest))
    : undefined;
